"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Markdown = exports.LinkRenderer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_easy_emoji_1 = __importDefault(require("react-easy-emoji"));
const react_markdown_1 = __importDefault(require("react-markdown"));
const react_router_hash_link_1 = require("react-router-hash-link");
const contexts_1 = require("./contexts");
const RuleLink_1 = require("./RuleLink");
const PublicodesBlock_1 = __importDefault(require("./PublicodesBlock"));
function LinkRenderer(_a) {
    var { href, children } = _a, otherProps = __rest(_a, ["href", "children"]);
    const engine = react_1.useContext(contexts_1.EngineContext);
    if (!engine) {
        throw new Error('an engine should be provided in context');
    }
    if (href && href in engine.getParsedRules()) {
        return (jsx_runtime_1.jsx(RuleLink_1.RuleLinkWithContext, Object.assign({ dottedName: href }, otherProps, { children: children }), void 0));
    }
    if (href && !href.startsWith('http')) {
        return (jsx_runtime_1.jsx(react_router_hash_link_1.HashLink, Object.assign({ to: href }, otherProps, { children: children }), void 0));
    }
    return (jsx_runtime_1.jsx("a", Object.assign({ target: "_blank", href: href }, otherProps, { children: children }), void 0));
}
exports.LinkRenderer = LinkRenderer;
const CodeBlock = ({ value, language }) => language === 'yaml' ? (jsx_runtime_1.jsx(PublicodesBlock_1.default, { source: value }, void 0)) : (jsx_runtime_1.jsx("pre", { children: jsx_runtime_1.jsx("code", { children: value }, void 0) }, void 0));
const TextRenderer = ({ children }) => (jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: react_easy_emoji_1.default(children) }, void 0));
const Markdown = (_a) => {
    var { source, className = '', renderers = {} } = _a, otherProps = __rest(_a, ["source", "className", "renderers"]);
    return (jsx_runtime_1.jsx(react_markdown_1.default, Object.assign({ source: source, className: `markdown ${className}`, renderers: Object.assign({ link: LinkRenderer, text: TextRenderer, code: CodeBlock }, renderers) }, otherProps), void 0));
};
exports.Markdown = Markdown;
